var React = require('react');

function Dribbble (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm20.2-20.7c-.7-.2-6.3-1.9-12.8-.9 2.7 7.4 3.8 13.4 4 14.6 4.7-3.1 7.9-8 8.8-13.7zM32 42.9c-.3-1.8-4.4-15.5-4.4-15.5-11.6 4-15.8 12.1-16.2 12.8 3.5 2.7 7.8 4.3 12.6 4.3 2.8 0 5.5-.5 8-1.6zM8.8 37.7c.5-.8 5.7-10 17.5-13.8 0 0-1.1-2.3-1.7-3.5-10.2 3.1-20.2 2.9-21.1 2.9v.6c0 5.4 2 10.2 5.3 13.8zM3.9 19.8c.9 0 9.4 0 19-2.5-3.4-6-7.1-11.1-7.6-11.9-5.8 2.8-10 8.1-11.4 14.4zM19.2 4.1c.6.8 4.3 5.8 7.6 12 7.3-2.7 10.4-6.9 10.7-7.4C34 5.5 29.2 3.5 24 3.5c-1.7 0-3.3.2-4.8.6zm20.7 7c-.4.6-3.9 5-11.4 8.1.5 1 1.7 3.7 1.8 4 6.8-.9 13.6.5 14.3.7-.1-4.9-1.9-9.3-4.7-12.8z"}));
}

Dribbble.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Dribbble;

Dribbble.default = Dribbble;
